export default __webpack_public_path__ + "static/media/Star.d74f1153.svg";